import router from '@/router'
import { getGameConfigById } from '@/hooks/useGameConfig'
import { useGameStore } from '@/store/modules/game'

export const UseGetCurrentGameConfigHooks = () => {
  const route = router.currentRoute.value
  const { setCurrentGameId, setCurrentGameConfig } = useGameStore()
  const currentGameConfig = getGameConfigById(route.path as string)

  const setGameConfig = () => {
    const gameConfig = getGameConfigById(route.path as string)
    console.log('gameConfig', gameConfig)
    setCurrentGameConfig(gameConfig)
    setCurrentGameId(gameConfig.id)
  }

  return {
    setGameConfig,
    currentGameConfig
  }
}
